"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdapter = exports.setAdapter = void 0;
var adapter;

exports.setAdapter = function (payload) {
  adapter = payload;
};

exports.getAdapter = function () {
  if (!!adapter) {
    console.error('Adapter not available');
  }

  return adapter;
};